<template>
  <div
    class="fixed z-10 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >

      <div
        class="inline-block align-center bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden sm:min-h-auto shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
      >
        <div>
          <div>
            <h3 class="text-lg leading-6 font-medium text-indigo-700">
              Lender Information - Agent Information
            </h3>
            <p class="mt-1 text-sm text-gray-500">
              Use a permanent address where you can receive mail.
            </p>
          </div>

          <template v-if="type == 'agent'">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="selected[0].name"
                    class="shadow-sm focus:ring-indigo-500 p-1 border focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-3">
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  Phone
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="selected[0].phone"
                    class="shadow-sm focus:ring-indigo-500 p-1 border focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-3">
                <label
                  for="email"
                  class="block text-sm font-medium text-gray-700"
                >
                  Email address
                </label>
                <div class="mt-1">
                  <input
                    type="email"
                    autocomplete="email"
                    v-model="selected[0].email"
                    class="p-1 border shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>
            </div>

            <div
              class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
            >
              <button
                @click.prevent="updateAgent(selected[0])"
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
              >
                Save
              </button>
              <button
                @click="closeModal"
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
              >
                Cancel
              </button>
            </div>
          </template>

          <template v-else-if="type == 'lender'">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <span class="flex text-pink-600">
                <i class="far fa-file-pdf"></i>
                <b class="ml-2 text-sm"> {{ pdfFile }} </b>
              </span>

              <div class="sm:col-span-6">
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="selected[0].name"
                    class="shadow-sm focus:ring-indigo-500 p-1 border focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-3">
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  Phone
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="selected[0].phone"
                    class="shadow-sm focus:ring-indigo-500 p-1 border focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-3">
                <label
                  for="email"
                  class="block text-sm font-medium text-gray-700"
                >
                  Email address
                </label>
                <div class="mt-1">
                  <input
                    type="email"
                    autocomplete="email"
                    v-model="selected[0].website"
                    class="p-1 border shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div class="sm:col-span-6">
                <label
                  for="photo"
                  class="block text-sm font-medium text-gray-700"
                >
                  Add a new Pre-Approval
                </label>
                <div class="mt-1 flex items-center">
                  <span
                    class="h-12 w-12 rounded-full overflow-hidden bg-gray-200"
                  >
                    <svg
                      class="h-full w-full text-gray-600"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 48 48"
                      aria-hidden="true"
                    >
                      <path
                        d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <div class="flex text-xs ml-2 text-gray-600">
                    <label
                      for="file-upload"
                      class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                    >
                      <span>Upload a file</span>
                      <input
                        @change="uploadApproval"
                        id="file-upload"
                        name="file-upload"
                        type="file"
                        class="sr-only"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
            >
              <button
                @click.prevent="updateLender(selected[0])"
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
              >
                Save
              </button>
              <button
                @click="closeModal"
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
              >
                Cancel
              </button>
            </div>
          </template>

          <template v-else-if="type == 'pdf'">
            <embed v-if="isDisplay" :src="filePath" width="100%" class="h-96" />
            <embed
              v-else
              :src="
                'https://homesby360.s3.amazonaws.com/Pre-Approvals/' + selected
              "
              width="100%"
              class="h-96"
            />

            <button
              @click="closeModal"
              type="button"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
            >
              Cancel
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>

<script>
import Swal from "sweetalert2";
export default {
  props: ["selected", "type", "pdfFile", "isDisplay", "filePath"],
  data() {
    return {
      preApproval: ""
    };
  },

  methods: {
    uploadApproval(e) {
      this.preApproval = e.target.files || e.dataTransfer.files;
    },

    closeModal() {
      this.$emit("hideModal");
    },

    updateLender(lender) {
      var config = {
        headers: { "Content-Type": "multipart/form-data" }
      };

      let pdfDoc = new FormData();

      $.each(this.preApproval, function(key, image) {
        pdfDoc.append(`image[${key}]`, image);
      });

      pdfDoc.append("id", lender.id);
      pdfDoc.append("name", lender.name);
      pdfDoc.append("website", lender.website);
      pdfDoc.append("phone", lender.phone);

      window.axios.post("/api/updateLender", pdfDoc, config).then(() => {
        this.getUser();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Lender successfully updated",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    updateAgent(agent) {
      window.axios.post("/api/updateAgent/" + agent.id, agent).then(() => {
        this.getUser();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Agent successfully updated",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    getUser() {
      this.$store.dispatch("getUser");
      this.closeModal();
    }
  }
};
</script>
